module.exports = __webpack_public_path__ + "web.config";